<template>
    <div class="">
        <b-modal 
            :model-value="modalAdActivos" 
            @update:model-value="updateModalValue"
            :no-close-on-backdrop="false" 
            hide-header 
            hide-footer 
            centered
            size="md"
        >
            <div class="text-center mb-3">
                <h5>{{ labels.title }} {{ numContrato }}</h5>
            </div>
            
            <div class="">
                <b-row class="text-center" v-if="listActivos?.length > 0"> 
                    <b-col cols="12">
                        <label class="font-weight-bold">{{ labels.selectAssets }}</label>
                        <select 
                            multiple 
                            class="form-control" 
                            v-model="activosSelected"
                            size="5"
                        >
                            <option 
                                v-for="activo in listActivos" 
                                :key="activo.id" 
                                :value="activo.id"
                            >
                                {{ activo.descripcion }}
                            </option> 
                        </select>
                        <small class="text-muted">{{ labels.selectHelp }}</small>
                    </b-col>
                </b-row>
                
                <b-row class="justify-content-center" v-else>
                    <h6 class="text-muted">{{ labels.noData }}</h6> 
                </b-row>
                
                <div class="mt-3 d-flex justify-content-center gap-2">
                    <b-col cols="4">
                        <b-button 
                            variant="primary" 
                            @click="aceptaActivos"
                            :disabled="activosSelected.length === 0"
                            block
                        >
                            {{ labels.save }}
                        </b-button> 
                    </b-col>
                    <b-col cols="3">
                        <b-button 
                            variant="secondary" 
                            @click="cierraModal"
                            block
                        >
                            {{ labels.close }}
                        </b-button> 
                    </b-col>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato' 
import Activos from '../../services/Activos' 

export default {
    name: 'AdicionarActivos',
    props: {
        modalAdActivos: {
            type: Boolean,
            required: true,
            default: false
        },
        numContrato: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            activosSelected: [],
            listActivos: [],
            listContrato: [],
            isLoading: false
        }
    },
    computed: {
        labels() {
            const isSpanish = this.$store.state._language === "es-ES"
            return {
                title: isSpanish ? 'Adición de activos al contrato Nro.' : 'Addition of assets to contract No.',
                save: isSpanish ? 'Guardar' : 'Save',
                close: isSpanish ? 'Cerrar' : 'Close',
                detalle: isSpanish ? 'Modificación Detalle' : 'Detail',
                activos: isSpanish ? 'Modificación Activos' : 'Assets',
                cuotas: isSpanish ? 'Cuotas' : 'Installments',
                noData: isSpanish ? 'No hay activos disponibles.' : 'No assets available.',
                selectAssets: isSpanish ? 'Seleccione los activos a agregar (Ctrl + click para múltiple)' : 'Select assets to add (Ctrl + click for multiple)',
                selectHelp: isSpanish ? 'Mantenga presionada la tecla Ctrl para seleccionar múltiples activos' : 'Hold Ctrl key to select multiple assets'
            }
        }
    },
    methods: {
        updateModalValue(value) {
            this.$emit('update:modalAdActivos', value)
        },
        
        cierraModal() {
            this.$emit('update:modalAdActivos', false)
            this.$emit('cierraModal', false)
            // Limpiar selección al cerrar
            this.activosSelected = []
        },
        
        async aceptaActivos() {
            if (this.activosSelected.length === 0) {
                this.$toast.warning(this.$store.state._language === "es-ES" 
                    ? 'Seleccione al menos un activo' 
                    : 'Select at least one asset'
                )
                return
            }
            
            if (this.isLoading) return
            
            this.isLoading = true
            
            try {
                const info = {
                    'lstAct': this.activosSelected,
                    'numContrato': this.numContrato,
                    'idUser': this.$store.state.userId
                }
                
                const res = await Activos.addNewActivoAlContrato(info)
                
                if (res.status === 200) {
                    this.$toast.success(res.data.message)
                    this.cierraModal()
                    
                    // Emitir evento para actualizar la lista en el componente padre
                    this.$emit('activosActualizados')
                    
                    // Esperar un momento antes de recargar si es necesario
                    setTimeout(() => {
                        // Usar $router.replace en lugar de reload para mejor UX
                        this.$router.replace('/modificarcontrato')
                    }, 500)
                }
            } catch (error) {
                console.error('Error al agregar activos:', error)
                if (error.response && error.response.data) {
                    this.$toast.error(error.response.data.message)
                } else {
                    this.$toast.error(this.$store.state._language === "es-ES" 
                        ? 'Error al agregar los activos' 
                        : 'Error adding assets'
                    )
                }
            } finally {
                this.isLoading = false
            }
        },
        
        async cargarDatos() {
            try {
                const resContrato = await Contrato.leaContrato(this.numContrato)
                this.listContrato = resContrato.data.contrato
                
                if (this.listContrato.length > 0) {
                    const resActivos = await Activos.leaActivosColocar(
                        this.listContrato[0].identificacion,
                        this.listContrato[0].tipo_activo
                    )
                    this.listActivos = resActivos.data.listActivos || []
                }
            } catch (err) {
                console.error('Error cargando datos:', err)
                this.$toast.error(this.$store.state._language === "es-ES" 
                    ? 'Error al cargar los datos' 
                    : 'Error loading data'
                )
            }
        }
    },
    watch: {
        modalAdActivos(newValue) {
            if (newValue) {
                // Resetear selección al abrir
                this.activosSelected = []
                this.cargarDatos()
            }
        }
    },
    mounted() {
        if (this.modalAdActivos) {
            this.cargarDatos()
        }
    }
}
</script>

<style scoped>
.gap-2 {
    gap: 0.5rem;
}
.b-table-cell-container { 
    padding: 15px !important;
}
.b-table-head-label { 
    padding-left: 30px !important;
}

/* Estilos adicionales para mejorar la apariencia */
select.form-control[multiple] {
    min-height: 150px;
}

select.form-control[multiple] option {
    padding: 8px 12px;
    border-bottom: 1px solid #f0f0f0;
}

select.form-control[multiple] option:hover {
    background-color: #e8f0fe;
}

select.form-control[multiple] option:checked {
    background-color: #0d6efd;
    color: white;
}
</style>
